import ajax from './ajax';
import filters from './filters';
import auth from './auth';
import ua from './ua';

export default (Vue) => {
  // 加载全局过滤器：filters
  Vue.use(filters);
  // 加载aajax
  Vue.use(ajax);
  Vue.use(auth);
  Vue.prototype.$urlEncode = params => $.param(params);
  // Vue.prototype.$urlEncode = (param, key, encode) => {
  //   if (param == null) return '';
  //   let paramStr = '';
  //   const t = typeof (param);
  //   if (t === 'string' || t === 'number' || t === 'boolean') {
  //     paramStr += `&${key}=${(encode === null || encode) ? encodeURIComponent(param) : param}`;
  //   } else {
  //     Object.keys(param).forEach((i) => {
  //       const k = key === null ? i : key + (param instanceof Array ? `[${i}]` : `.${i}`);
  //       paramStr += this.$urlEncode(param[i], k, encode);
  //     });
  //     // for (const i in param) {
  //     //   const k = key === null ? i : key + (param instanceof Array ? `[${i}]` : `.${i}`);
  //     //   paramStr += urlEncode(param[i], k, encode);
  //     // }
  //   }
  //   return paramStr;
  // };
  Vue.use(ua);
};



// WEBPACK FOOTER //
// ./src/utils/index.js